import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import { AvatarComponent, CheckboxComponent } from '@core/user-interface-legacy';
import type { AnyGroup, GroupSelectionType, LayoutBoardGroupHeader } from '@core/views-types';
import { BoardGroupHeaderComponent } from '@core/views-ui';

@Component({
  selector: 'rt-group-header',
  imports: [
    BoardGroupHeaderComponent,
    AvatarComponent,
    OfferStatusIndicatorComponent,
    CheckboxComponent,
  ],
  templateUrl: './group-header.component.html',
  styleUrls: ['./group-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsGroupHeaderComponent implements LayoutBoardGroupHeader {
  public group = input.required<AnyGroup>();
  public selectionInGroup = input.required<GroupSelectionType>();
  public count = input.required<number | null | undefined>();

  public select = output<AnyGroup>();
}
